import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
    Table, Typography, notification, Button, Popconfirm
} from 'antd';
import {
    DeleteOutlined
} from '@ant-design/icons';

import moment from 'moment';

import { convertDataUSParaBrasil } from '../../../../../services/Conversores';
import { useNavigate } from 'react-router-dom';
import locale from 'antd/es/locale/pt_BR';
import { urlVeiculoProprio, urlVeiculoProprioEmpresa } from '../../../../../services/urls';
import { EmitirErro } from '../../../../../services/EmitirErro';
import { SairDoSistema } from '../../../../../services/LStorage/SairSistema';
import { api } from '../../../../../services/apiAxios';
import { getToken } from '../../../../../services/LStorage/token';
import { useGetColumnSearchProps } from '../../../../../hooks/FilterTable/string';
import { useGetColumnSearchPropsData } from '../../../../../hooks/FilterTable/date';
import { GlobalContext } from '../../../../../contexts/globalContext';
import './style.css';
import { useGetColumnSearchPropsObjTipo } from './filterTipoTable';


const { Text } = Typography;

// const largura = window.innerWidth;
// const altura = window.innerHeight;
interface IntefEmpresas {
    "id": string,
    "createdAt": string,
    "updatedAt": string,
    "ativo": boolean,
    "nome": string,
    "cnpj": string,
    "telefone": string,
    "bairro": string | null,
    "cep": string | null,
    "cidade": string | null,
    "logradouro": string | null,
    "numero": string | null,
    "uf": string | null,
    "deletedAt": string | null
}
interface IntefDadosTable {
    cor: string,
    "createdAt": string,
    descricao: string,
    empresaId: string,
    "id": string,
    noPatio: boolean
    placa: string,
    tipo: string,
    updatedAt: string
}

type interfOpcaoScreen = 'listar' | 'addUpdate';

interface interPros {
    empresaSelecionado?: IntefEmpresas,
    alterOpcaoScreen: (opcao: interfOpcaoScreen, id?: string) => void;
}

export const ListagemVeiculos = ({ empresaSelecionado, alterOpcaoScreen }: interPros) => {

    const navigate = useNavigate();

    const { theme } = useContext(GlobalContext);

    const refContagemDoFiltro = React.useRef<Array<any>>([]);
    const refEmpresaSelecionada = React.useRef<IntefEmpresas | null | undefined>(null);

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<IntefDadosTable>>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string | number>>([]);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);


    const [loadingScreen, setLoadingScreen] = useState(false);

    //setando dados das cidades no selected
    const buscaDadosList = useCallback((id?: string) => {


        const funcBusca = async () => {
            try {
                setLoadingScreen(true);
                let result = await api.get(urlVeiculoProprioEmpresa + '/' + id,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + getToken()
                        }
                    });

                setDadosTabelaState(result.data);

                setLoadingScreen(false);

            } catch (error) {
                setLoadingScreen(false);
                let msgErro: any = (error as Error);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'usuarios_dkwdfaiweyi')
                }


            }
        }

        funcBusca();

    }, []);

    useEffect(() => {

        refEmpresaSelecionada.current = empresaSelecionado
        if (empresaSelecionado) buscaDadosList(empresaSelecionado.id);

    }, [empresaSelecionado]);


    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.id)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.id
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.id]);
                setHasSelectedEdit(true);
            } else {
                let teste = selectedRowKeys.concat(record.id);
                setSelectedRowKeys(teste);
                setHasSelectedEdit(false);
            }
        }
    }, [selectedRowKeys]);

    //checkbox da tabela de listagem
    // const onSelectChange = useCallback((selectedRowKeys: any): void => {
    const onSelectChange = useCallback((selectedRowKeys: Array<string | number>, selectedRows: Array<any>): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const columns = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            ...useGetColumnSearchProps('descricao'),
            width: '10%',
            sorter: (a: any, b: any) => a.descricao.localeCompare(b.descricao),
            showSorterTooltip: false,
        },
        {
            title: 'Placa',
            dataIndex: 'placa',
            ...useGetColumnSearchProps('placa'),
            width: '10%',
            sorter: (a: any, b: any) => a.placa.localeCompare(b.placa),
            showSorterTooltip: false,
        },
        {
            title: 'Cor',
            dataIndex: 'cor',
            ...useGetColumnSearchProps('cor'),
            width: '10%',
            sorter: (a: any, b: any) => a.cor.localeCompare(b.cor),
            showSorterTooltip: false,
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
            ...useGetColumnSearchPropsObjTipo('tipo'),
            width: '10%',
            sorter: (a: any, b: any) => a.tipo?.tipo.localeCompare(b.tipo.tipo),
            showSorterTooltip: false,
            render: (tipo: any) => {
                return tipo?.tipo;
            }
        },
        {
            title: 'Quilometragem atual',
            dataIndex: 'ultimo_km_chegada',
            ...useGetColumnSearchProps('ultimo_km_chegada'),
            width: '10%',
            sorter: (a: any, b: any) => a.ultimo_km_chegada.localeCompare(b.ultimo_km_chegada),
            showSorterTooltip: false,
            render: (ultimo_km_chegada: any) => {
                return ultimo_km_chegada;
            }
        },
        {
            title: 'Criado em',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
            render: (criado: any) => (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Text>
                        {
                            criado ? convertDataUSParaBrasil(criado) : '-'
                        }
                    </Text>
                </div>
            ),
        },
    ];

    const handleClickEditarVeiculo = useCallback(() => {

        if (selectedRowKeys.length == 1) {

            let objSelecionado: any = {}
            dadosTabelaState.forEach((dados): void => {
                if (dados.id === selectedRowKeys[0]) {
                    objSelecionado = dados
                }
            })

            localStorage.setItem('@SisPortaria:veiculoEditForEmpresa', JSON.stringify(objSelecionado));

            alterOpcaoScreen('addUpdate', selectedRowKeys[0].toString())


        }
    }, [selectedRowKeys, dadosTabelaState]);

    const clickBotaoDELETARVeiculo = useCallback((): void => {
        if (selectedRowKeys.length == 1) {

            const funcBusca = async () => {
                try {
                    setLoadingScreen(true);

                    let objSelecionado: any = null
                    dadosTabelaState.forEach((dados): void => {
                        if (dados.id === selectedRowKeys[0]) {
                            objSelecionado = dados
                        }
                    })


                    if (objSelecionado && empresaSelecionado) {

                        await api.delete(urlVeiculoProprio +
                            '/' + objSelecionado!.id,
                            {
                                headers: {
                                    'Authorization': 'Bearer ' + getToken()
                                }
                            });

                        setSelectedRowKeys([])
                        buscaDadosList(empresaSelecionado.id)

                    }

                    setLoadingScreen(false);

                } catch (error) {
                    setLoadingScreen(false);
                    let msgErro: any = (error as Error);

                    if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                        SairDoSistema();
                        notification.error({
                            message: 'Sessão expirada',
                            description:
                                'Sua sessão expirou, realize o login novamente!',
                        });
                        navigate('/');
                    } else {
                        EmitirErro(error, true, 'usuarios_dkwdfaiweyi')
                    }


                }
            }

            funcBusca();

        }
    }, [selectedRowKeys, dadosTabelaState, empresaSelecionado]);

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    // justifyContent: 'flex-end',
                    // justifyContent: 'flex-end'
                    marginBottom: 15
                }}
            >
                <Button
                    type="primary"
                    className="ListVeiculos_BotaoAdd_efwAIUYG"
                    style={{ margin: 2 }}
                    // disabled={!hasSelectedAdd}
                    onClick={() => {
                        let dadosLocalStorage: string | null = localStorage.getItem('@SisPortaria:veiculoEditForEmpresa');
                        let localUserData: any = null;
                        if (typeof dadosLocalStorage == 'string') {
                            localUserData = JSON.parse(dadosLocalStorage);
                        }

                        if (localUserData) {
                            localStorage.removeItem('@SisPortaria:veiculoEditForEmpresa');
                        }

                        alterOpcaoScreen('addUpdate')
                    }}
                >
                    Adicionar
                </Button>
                <Button
                    type="default"
                    style={{ margin: 2 }}
                    className="ListVeiculos_BotaoEditar_atiuhcvqweriuf"
                    onClick={handleClickEditarVeiculo}
                    disabled={!hasSelectedEdit}
                >
                    Editar
                </Button>
                {
                    hasSelectedEdit ?
                        <Popconfirm
                            key="pop"
                            placement="topRight"
                            title={() => (
                                <div>
                                    <Text>
                                        {`Deseja realmente excluir veículo?`}
                                    </Text>
                                </div>
                            )}
                            onConfirm={() => clickBotaoDELETARVeiculo()}
                            onCancel={() => { }}
                            okText="Sim"
                            cancelText="Não"
                        >
                            <Button
                                type="primary"
                                style={{ margin: 2 }}
                                disabled={!hasSelectedEdit}
                                danger
                            >
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                        :
                        <Button
                            type="primary"
                            style={{ margin: 2 }}
                            disabled={!hasSelectedEdit}
                            danger
                        >
                            <DeleteOutlined />
                        </Button>
                }
            </div>
            <Table
                style={{
                    // marginTop: 50
                }}
                className='marginTopTables'
                rowKey={(record) => record.id}
                loading={loadingScreen}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) }
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={dadosTabelaState}
                scroll={{ x: 650 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {

                    return (
                        <div
                            style={{
                                backgroundColor: theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 50,
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />

        </>
    );
}
